export default __webpack_public_path__ + "static/abajo-izq1-05687138f14cb66a00d273d0d0c07b08.png";